import { FlowRateUnits } from "@/libs/units/flowRate";
import { PercentageUnits } from "@/libs/units/percentage";
import {
  getHpsSingleLiquidRateLabel,
  getHpsTotalLiquidRateLabel
} from "@/utils/hpsLiquidType";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderWellTargetCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => {
  const hpsLiquidType = scenario.wellProperties.value?.hps_liquid_type;

  return [
    {
      section: "Well Target",
      label: "Target Productivity Index",
      targetUnit: targetUnits.productivityFlowUnit,
      value: calcs.productivityIndexStbdPsia.value
    },
    {
      section: "Well Target",
      label: `${getHpsTotalLiquidRateLabel(hpsLiquidType)} Target Rate`,
      targetUnit: targetUnits.liquidFlowUnit,
      value: calcs.surfaceFlowRates.value.liquidFlowRateSTBD
    },
    {
      section: "Well Target",
      label: "Water Cut",
      targetUnit: PercentageUnits.Percentage,
      value: calcs.surfaceFlowRates.value.waterCutPercentage
    },
    {
      section: "Well Target",
      label: "Oil Target Rate",
      targetUnit: targetUnits.liquidFlowUnit,
      value: calcs.surfaceFlowRates.value.oilFlowRateSTBD
    },
    {
      section: "Well Target",
      label: `${getHpsSingleLiquidRateLabel(hpsLiquidType).replace(
        " Rate",
        " Target Rate"
      )}`,
      targetUnit: targetUnits.liquidFlowUnit,
      value: calcs.surfaceFlowRates.value.waterFlowRateSTBD
    },
    {
      section: "Well Target",
      label: "Gas Target Rate",
      targetUnit: targetUnits.gasFlowUnit,
      value: FlowRateUnits.CubicFeetPerDay.toStandardUnit(
        calcs.surfaceFlowRates.value.gasFlowRateSCFD
      )
    },
    {
      section: "Well Target",
      label: "Gas/Oil Ratio",
      targetUnit: targetUnits.liquidRatioUnit,
      value: calcs.surfaceFlowRates.value.gasOilRatioSCFSTB
    },
    {
      section: "Well Target",
      label: "Gas/Liquid Ratio",
      targetUnit: targetUnits.liquidRatioUnit,
      value: calcs.surfaceFlowRates.value.gasLiquidRatioSCFSTB
    },
    {
      section: "Well Target",
      label: "Total Equipment Length",
      targetUnit: targetUnits.largeLengthUnit,
      value: calcs.equipmentLengths.equipmentLengthFt.value
    }
  ];
};
